/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");
(function() {

var ecmLogServer = "log.cresendo.net";
var ecmCookieDays = 7;
var ecmtoday = new Date();
var ecmToDay = ecmtoday.getFullYear() + "" + FN_ZoneMark(ecmtoday.getMonth())	+ "" + FN_ZoneMark(ecmtoday.getDate());
var ecmID = "ridi";
var ecmGoodNm = "";
var ecmAmount = "";
var ecmTarget = "";
var ecmLogSend = "Y";
var ecmCV = "";
var ecmPN = "";

function FN_ZoneMark(_Ea) { if (_Ea < 10) { return "0" + _Ea; } else { return _Ea; }}
function FN_GetDomain(_Eb) {
	var _s = _Eb.split(".");
	if (_s.length == 3) {
		if (_s[1].length == 2 || _s[1]=="com") {
			return _Eb;
		} else {
			return _s[1] + "." + _s[2];
		}
	} else if (_s.length > 3) {
		if (_s[_s.length - 2].length == 2 || _s[_s.length - 2]=="com") {
			return _s[_s.length - 3] + "." + _s[_s.length - 2] + "." + _s[_s.length - 1];
		} else {
			return _s[_s.length - 2] + "." + _s[_s.length - 1];
		}
	} else {
		return _Eb;
	}
}
function FN_SetCookie(_Ec, _Ed, _Ee, _Ef, _Eg) {
	var _dt = new Date();
	_ut = _dt.getTime();
	_Ee = (!_Ee) ? "/" : _Ee;
	if (_Ed == null) { _Eg = 0; }
	if (_Eg != null) {
		_et = _ut + (_Eg * 1000);
		_dt.setTime(_et);
		_pt = " expires=" + _dt.toUTCString() + ";";
	} else {
		_pt = "";
	}
	if (_Ef != null) {
		_pt += " domain=" + _Ef + ";";
	}
	document.cookie = _Ec + "=" + escape(_Ed) + "; path=" + _Ee + ";" + _pt;
}
function FN_GetCookie(_Ec) {
	var _RT = document.cookie.match ( '(^|;) ?' + _Ec + '=([^;]*)(;|$)' );
	if ( _RT) {
		return unescape(_RT[2]);
	} else {
		return "";
	}
}
function FN_StrPos(_Eh, _Ei) {
	for (var _i = 0; _i < _Eh.length; _i++) {
		if (_Eh.substring(_i, _i + 1) == _Ei) {
			return _i;
		}
	}
	return -1;
}
function FN_FullDomain(_Ej) {
	if (FN_StrPos(_Ej, ":") > 0) {
		_Ej = _Ej.substring(0, FN_StrPos(_Ej, ":"));
	}
	if (FN_StrPos(_Ej, "/") > 0) {
		_Ej = _Ej.substring(0, FN_StrPos(_Ej, "/"));
	}
	_Ej = FN_GetDomain(_Ej);
	return _Ej;
}
function FN_sendChk(msecs){
	var start =new Date().getTime();
	var cur=start;
	while(cur-start<msecs){
		cur=new Date().getTime();
	}
}

var _LandYn = "N";
var _BookMark = "N";
var _ecmPR = window.location.protocol.indexOf("https");
var _ecmHostName = window.location.hostname;
var _ecmSearch = window.location.search;
var _ecmHash = window.location.hash;
var _ecmUL = document.URL;
var _ecmRF = document.referrer;
var _ecmDoMain = FN_FullDomain(_ecmHostName);
var _ecmAK = FN_GetCookie(ecmID + "_CTNAAKEY");
var _ecmCK = FN_GetCookie(ecmID + "_CTNACKEY");
var _ecmSS = FN_GetCookie(ecmID + "_CTNASESSION");
var _ecmDate = FN_GetCookie(ecmID + "_CTNADATE");
var _ecmInKey ="";
var _ecmCV = "";
var _ecmPN = "";
var _ecmK = "";
var _ecmLogSend = "";
var _ecmSendCheck = "Y";
var _ecmSendParam = _ecmUL.toUpperCase().indexOf("CTNASEND=");
var _ecmULeKey = _ecmUL.toUpperCase().indexOf("CTNAKEY=");
var _ecmULTemp = "";
var _ecmULSubDomain = "";
var _ecmRFTemp = "";
var _ecmRFSubDomain = "";
if ( _ecmSendParam>0 ){
	var _ii = _ecmUL.indexOf("&", _ecmSendParam+9);
	if ( _ii>0 ) { _ecmSendCheck = _ecmUL.substring(_ecmSendParam+9, _ii); }
	else { _ecmSendCheck = _ecmUL.substring(_ecmSendParam+9); }
}
_ecmSendCheck = _ecmSendCheck.toUpperCase();
if ( _ecmSendCheck != "N" ) {
	if (_ecmUL.charAt(_ecmUL.length - 1) == "/") {
		_ecmUL = _ecmUL.substring(0, _ecmUL.length - 1);
	}

	if (!_ecmRF || _ecmRF == "") {
		_ecmRFSubDomain = "";
	} else {
		_ecmRF = _ecmRF.replace("'", "");
		_ecmRFTemp = _ecmRF.replace("http://", "");
		_ecmRFTemp = _ecmRFTemp.replace("https://", "");
		_ecmRFSubDomain = FN_FullDomain(_ecmRFTemp);
	}

	_ecmUL = _ecmUL.replace("'", "");
	_ecmULTemp = _ecmUL.replace("http://", "");
	_ecmULTemp = _ecmULTemp.replace("https://", "");
	_ecmULSubDomain = FN_FullDomain(_ecmULTemp);

	if (_ecmRFSubDomain != "") {
		if (_ecmULSubDomain != _ecmRFSubDomain && _ecmULeKey > 0) {
			_LandYn = "Y";
		}
	} else {
		if (_ecmCK != "") {
			_BookMark = "Y";
			_ecmInKey = _ecmCK;
		}
	}

	if (_LandYn == "Y" || _ecmULeKey > 0 ) {
		var _ii = _ecmUL.indexOf("&", _ecmULeKey + 8);
		if (_ii > 0) {
			_ecmK = _ecmUL.substring(_ecmULeKey + 8, _ii);
		} else {
			_ecmK = _ecmUL.substring(_ecmULeKey + 8);
		}
		var _ss = _ecmK.indexOf("#");
		if ( _ss > 0 ) {
			_ecmK = _ecmK.substring(0, _ss);
		}
		FN_SetCookie(ecmID + "_CTNAKEY", _ecmK, "/", _ecmDoMain);

		if (!_ecmK || _ecmK == "") {
			_ecmK = "unknown";
		}
		if (_ecmK != "unknown") {
			_ecmCK = _ecmK;
			_ecmDate = ecmToDay;
			FN_SetCookie(ecmID + "_CTNACKEY", _ecmK, "/", _ecmDoMain,	ecmCookieDays * 24 * 60 * 60);
			FN_SetCookie(ecmID + "_CTNADATE", ecmToDay, "/", _ecmDoMain,ecmCookieDays * 24 * 60 * 60);
			if (!_ecmSS || _ecmSS == "") {
				var _DT = new Date();
				_ecmSS = ((Math.round(Math.random() * 900) % 900 + 100)) + ""+ _DT.getTime();
				FN_SetCookie(ecmID + "_CTNASESSION", _ecmSS, "/", _ecmDoMain,	ecmCookieDays * 24 * 60 * 60);
			} else {
				FN_SetCookie(ecmID + "_CTNASESSION", _ecmSS, "/", _ecmDoMain,	ecmCookieDays * 24 * 60 * 60);
			}

			if (!_ecmAK || _ecmAK == "") {
				_ecmAK = _ecmK;
				FN_SetCookie(ecmID + "_CTNAAKEY", _ecmK, "/", _ecmDoMain,	1 * 24 * 60 * 60);
			}
		}
		if (_ecmPR > 0) {
			_ecmInKey = _ecmCK;
		} else {
			if (_ecmK == "unknown") {
				if (_ecmCK == "unknown") {
					_ecmInKey = _ecmAK;
				} else {
					_ecmInKey = _ecmCK;
				}
			} else {
				_ecmInKey = _ecmK;
			}
		}
	}

	if (_LandYn == "Y" || _BookMark == "Y") {
		if (_ecmInKey != "" || _ecmAK != "") {
			var _ecmLogUrl = "//" + ecmLogServer + "/?ac=" + ecmID + "&k=" + escape(_ecmInKey) + "&ak=" + escape(_ecmAK) + "&la=" + _LandYn+ "&bm=" + _BookMark
				+ "&gd=" + encodeURIComponent(ecmGoodNm)+ "&at=" + ecmAmount + "&ud=" + escape(_ecmULSubDomain) + "&ul=" + escape(_ecmUL) + "&rd=" + escape(_ecmRFSubDomain)
				+ "&rl=" + escape(_ecmRF) + "&pg=" + escape(_ecmUL.replace(_ecmSearch + _ecmHash, "")) + "&cd=" + _ecmDate + "&br=" + escape(navigator.appName)
				+ "&os=" + escape(navigator.userAgent) + "&et=" + ecmTarget + "&cv=&pn=&ss=" + _ecmSS + "&vr=6.3";
			var eLogxhr = new Image(); eLogxhr.src = _ecmLogUrl; FN_sendChk(300);
		}
	} else if ( _ecmULeKey > 0 ){
		var _ecmLogUrl = "//" + ecmLogServer + "/?ac=" + ecmID + "&k=" + escape(_ecmInKey) + "&ak=" + escape(_ecmAK) + "&la=" + _LandYn+ "&bm=" + _BookMark
				+ "&gd=" + encodeURIComponent(ecmGoodNm)+ "&at=" + ecmAmount + "&ud=" + escape(_ecmULSubDomain) + "&ul=" + escape(_ecmUL) + "&rd=" + escape(_ecmRFSubDomain)
				+ "&rl=" + escape(_ecmRF) + "&pg=" + escape(_ecmUL.replace(_ecmSearch + _ecmHash, "")) + "&cd=" + _ecmDate + "&br=" + escape(navigator.appName)
				+ "&os=" + escape(navigator.userAgent) + "&et=" + ecmTarget + "&cv=&pn=&ss=" + _ecmSS + "&vr=6.3";
		var eLogxhr = new Image(); eLogxhr.src = _ecmLogUrl; FN_sendChk(300);
	}
}

module.exports = function csf(tp, pn, gd, am) {
	var ecmGoodNm = (typeof(gd)=="undefined")?"":gd;
	var ecmAmount = (typeof(am)=="undefined")?"":am;
	var ecmCV = "Y";
	var ecmPN = pn;
	var _ecmInKey = _ecmCK;
	if ( _ecmSendCheck != "N" && tp == "event" ) {
		if (typeof(ecmCV)=="undefined" || typeof(ecmCV)!="string") { _ecmCV=""; } else { _ecmCV=ecmCV; }
		if (typeof(ecmPN)=="undefined" || typeof(ecmPN)!="string") { _ecmPN=""; } else { _ecmPN=ecmPN; }
		if (typeof(ecmLogSend)=="undefined" || typeof(ecmLogSend)!="string") { _ecmLogSend=""; } else { _ecmLogSend=ecmLogSend; }
		if (_ecmLogSend=="Y") {
			if (_ecmInKey!="" || _ecmAK!="") {
				if (_ecmCV=="Y") {
					var _ecmLogUrl = "//" + ecmLogServer + "/?ac=" + ecmID + "&k=" + escape(_ecmInKey) + "&ak=" + escape(_ecmAK) + "&la=" + _LandYn + "&bm=" + _BookMark
						+ "&gd=" + encodeURIComponent(ecmGoodNm) + "&at=" + ecmAmount + "&ud=" + escape(_ecmULSubDomain) + "&ul=" + escape(_ecmUL)
						+ "&rd=" + escape(_ecmRFSubDomain) + "&rl=" + escape(_ecmRF) + "&pg=" + escape(_ecmUL.replace(_ecmSearch + _ecmHash,"")) + "&cd=" + _ecmDate
						+ "&br=" + escape(navigator.appName) + "&os=" + escape(navigator.userAgent) + "&et=" + ecmTarget + "&cv=" + _ecmCV + "&pn=" + _ecmPN + "&ss=" + _ecmSS + "&vr=6.3";
					var eLogxhr = new Image(); eLogxhr.src = _ecmLogUrl; FN_sendChk(300);
				}
			}
		} else {
			var _ecmLogUrl = "//" + ecmLogServer + "/?ac=" + ecmID + "&k=" + escape(_ecmInKey) + "&ak=" + escape(_ecmAK) + "&la=" + _LandYn + "&bm=" + _BookMark
				+ "&gd=" + encodeURIComponent(ecmGoodNm) + "&at=" + ecmAmount + "&ud=" + escape(_ecmULSubDomain) + "&ul=" + escape(_ecmUL)
				+ "&rd=" + escape(_ecmRFSubDomain) + "&rl=" + escape(_ecmRF) + "&pg=" + escape(_ecmUL.replace(_ecmSearch + _ecmHash,"")) + "&cd=" + _ecmDate
				+ "&br=" + escape(navigator.appName) + "&os=" + escape(navigator.userAgent) + "&et=" + ecmTarget + "&cv=" + _ecmCV + "&pn=" + _ecmPN + "&ss=" + _ecmSS + "&vr=6.3";
			var eLogxhr = new Image(); eLogxhr.src = _ecmLogUrl; FN_sendChk(300);
		}
	}
}

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./ext/buildV63.js
// module id = OXoOAWeK
// module chunks = vendors.common